var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showPestSelectSection)?_c('PestSelectSection',{staticClass:"product-section-dropdown",attrs:{"selectedDropdownItem":_vm.selectedDropdownItem,"dropdownItems":_vm.dropdownItems},on:{"update":_vm.updateSelection,"open":_vm.updateCurrentActivityProductId}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }